// =============================================================================
// GeoSaver — Firebase Configuration
// Initialize Firebase SDK with env variables
// =============================================================================

import { initializeApp, getApps } from 'firebase/app'
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
}

// Initialize Firebase (singleton — prevent double init in dev mode)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]
const auth = getAuth(app)

// Ensure persistent auth across page navigations and browser restarts
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.warn('Firebase persistence setup failed:', err)
})

// Initialize Analytics (optional — will fail silently if not configured)
let analytics = null
if (typeof window !== 'undefined' && import.meta.env.VITE_FIREBASE_MEASUREMENT_ID) {
  try {
    analytics = getAnalytics(app)
  } catch (e) {
    // Analytics may fail in some environments — that's OK
    console.warn('Firebase Analytics initialization skipped:', e)
  }
}

export { app, auth, analytics }
